<template>
	<div class="agree-detail">
		<section class="top-fixing">
			<section class="common-sub-top agree-top container">
				<section class="top-info-wrap">
					<div class="prev-wrap">
						<span class="name-wrap">
							<strong @click="clickClose()" class="close"></strong>
						</span>
					</div>
					<!-- 선택-->
					<div class="select-wrap">
						<div class="select-change-off" @click="clickPenChartModify()">수정</div>
						<div class="select-change-off" @click="clickClose2">삭제</div>
					</div>
					<!-- //선택-->
				</section>
			</section>
		</section>
		<section class="agree-list2 container-fix">
			<!-- <img v-bind:src="`data:image/gif;base64,${this.items.image.imageBg}`" alt="동의서" />
						<img v-bind:src="`data:image/gif;base64,${this.items.image.imageLayer}`" alt="동의서" /> -->
			<!-- <img v-bind:src="`data:image/gif;base64,${this.items.image.imageLayer[0]}`" alt="동의서" class="test2" /> -->
			<ul>
				<li v-for="(item, idx) in items.image" :key="idx">
					<div class="img">
						<img :src="`data:image/gif;base64,${item.imageBg}`" alt="동의서" />
						<img :src="`data:image/gif;base64,${item.imageLayer}`" alt="동의서" class="layer" />
					</div>
				</li>
			</ul>
			<!-- 삭제 영억-->
			<section class="del-wrap">
				<a class="del_open"></a>
			</section>
			<!-- //삭제 영억-->
		</section>

		<!-- 삭제모달-->
		<section class="del-modal" id="del">
			<div class="alert">선택한 펜차트를<br />정말 삭제하시겠습니까?</div>
			<div class="btn-group">
				<a @click="deleteCancel()" class="btn-cancel del_close">취소</a>
				<a @click="deleteDoc()" class="btn-del">삭제</a>
			</div>
		</section>
		<JqueryCommon />
		<JqueryPopup />
	</div>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>
import JqueryCommon from '../../components/jquery/JqueryCommon';
import JqueryPopup from '../../components/jquery/JqueryPopup';

export default {
	components: {
		JqueryCommon,
		JqueryPopup
	},
	data: () => ({
		deleteJson: [{ receptNo: '', seqNo: '' }],
		url: '',
		items: {
			documentCd: '',
			endYmd: '',
			receiptNo: '',
			seqNo: ''
		},
		selectedInfo: null
	}),
	mounted() {
		this.selectedInfo = this.$route.params.selectedInfo;
		window.scrollTo({ top: 0 });
		try {
			var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
			if (varUA.match('android') != null) {
				window.penchart.setStatusBar('black');
			} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
				//IOS 일때 처리
				window.webkit.messageHandlers.setStatusBar.postMessage('black');
			}
		} catch (e) {
			console.log(e);
			//alert(e);
		}

		window.receiveAgreeList = this.receiveAgreeList;
		window.receivePenChartModify = this.receivePenChartModify;
		clearInterval(this.$store.state.timerId);
		if ($('#del_wrapper').length > 0) $('#del_wrapper').remove();

		$('#del').popup({
			transition: 'all 0.3s',
			blur: true,
			escape: true,
			scrolllock: true,
			closebutton: false,
			background: true,
			onclose: function () {
				document.body.style.overflow = 'visible';
			}
		});

		try {
			let url = `/penchart/viewer/${this.$route.params.receptNo}/${this.$route.params.seqNo}`;
			if (this.$osType === 'web' || this.$osType === 'ios') {
				this.$axios
					.get(url)
					.then(response => {
						this.items = response.data.data;
					})
					.catch(e => {
						console.log(e);
					});
			} else {
				let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
				this.items = result.data;
			}
		} catch (e) {
			console.log(e);
			//alert(e);
		}
	},
	methods: {
		deleteDoc() {
			$('.btn-cancel').click();
			let url = `/penchart`;
			let deleteJson = [
				{
					receptNo: this.$route.params.receptNo,
					seqNo: this.$route.params.seqNo
				}
			];

			if (this.$osType === 'web' || this.$osType === 'ios') {
				this.$axios
					.delete(url, {
						data: { data: deleteJson }
					})
					.then(() => {
						this.clickClose();
					})
					.catch(error => {
						console.log(error);
					});
			} else {
				let apiDeleteData = JSON.stringify({
					url: `${this.$store.state.apiDomain}${url}`,
					param: {
						data: deleteJson
					}
				});
				let result = this.$util.deleteApi(apiDeleteData);
				this.clickClose();
			}
		},
		clickClose() {
			try {
				var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
				if (varUA.match('android') != null) {
					window.penchart.setStatusBar('red');
				} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
					//IOS 일때 처리
					window.webkit.messageHandlers.setStatusBar.postMessage('red');
				}
			} catch (e) {
				console.log(e);
				//alert(e);
			}
			this.$router.push({
				name: '펜차트',
				params: {
					selectedInfo: this.$route.params.selectedInfo
				}
			});
		},
		clickClose2() {
			$('.del_open').click();
		},
		clickPenChartModify() {
			let json = `{"documentCd":"${this.items.documentCd}","documentNm":"","seqNo":"${this.items.seqNo}","receptNo":"${this.items.receptNo}","entEmpl":"1","ptntNo":"1","pageNo":"1","yyyyDate":"${this.$route.params.selectYYYY}"}`;
			console.log(json);
			try {
				var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
				if (varUA.match('android') != null) {
					window.penchart.callPenchartModify(json);
				} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
					//IOS 일때 처리
					window.webkit.messageHandlers.callPenchartModify.postMessage(json);
				}
			} catch (e) {
				console.log(e);
				//alert(e);
			}
		},
		async receiveAgreeList(documentCd, ptntNo, pageNo, yyyyDate) {
			this.$router
				.push({
					name: '펜차트',
					params: {
						selectedInfo: this.selectedInfo
						// page: pageNo,
						// documentCd: documentCd,
						// selectYYYY: yyyyDate
					}
				})
				.catch(e => {
					console.log('catch router ServiceSupportMy dupi');
				});
		},
		deleteCancel() {
			if (this.$osType === 'android') {
				window.penchart.setStatusBar('black');
			} else if (this.$osType === 'ios') {
				window.webkit.messageHandlers.setStatusBar.postMessage('black');
			}
		}
	}
};
</script>

<style scoped src="../../assets/css/page/patientAgreeDetail.css"></style>
